import {
  HStack, VStack, Text, Box, Link,
} from "@chakra-ui/react";
import { FiFileText, FiVideo, FiExternalLink, FiChevronRight } from "react-icons/fi";
import cdsColors from "theme/cdsColors";

interface ResourceItemProps {
  title: string;
  category: string;
  url: string;
  type: "document" | "video" | "link";
}

export default function ResourceItem({ title, category, url, type }: ResourceItemProps) {
  const getResourceIcon = (resourceType: string) => {
    switch (resourceType) {
      case "video": return <FiVideo size={16} />;
      case "document": return <FiFileText size={16} />;
      case "link": return <FiExternalLink size={16} />;
      default: return <FiFileText size={16} />;
    }
  };

  return (
    <Link href={url} target="_blank" rel="noopener noreferrer" _hover={{ textDecoration: "none" }}>
      <HStack
        p={3}
        bg="gray.50"
        borderRadius="md"
        _hover={{ bg: "gray.100" }}
        justify="space-between"
      >
        <HStack spacing={3} flex={1}>
          <Box color="brand.500">
            {getResourceIcon(type)}
          </Box>
          <VStack align="start" spacing={0} flex={1}>
            <Text fontSize="sm" fontWeight="medium" color="content.primary">
              {title}
            </Text>
            <Text fontSize="xs" color="content.tertiary">
              {category}
            </Text>
          </VStack>
        </HStack>
        <FiChevronRight size={16} color={cdsColors.cdsGrey[500]} />
      </HStack>
    </Link>
  );
}
